
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import ReactDom from 'react-dom'
import 'react-quill/dist/quill.snow.css';

export default function TextEditor(param: any) {

    const [editorValue, setEditorValue] = useState(""); // State to hold the editor content


        console.log(param)

    useEffect(() => {
        if (param && param.textvalue) {
            setEditorValue(param.textvalue)
        }

    }, [param]);


    const handleChange = (newValue: any) => {
        setEditorValue(newValue); // Update state on content change
        param.onchangeEditor(newValue)
    };
    const quillRef = useRef<ReactQuill>(null);


    return (
        <>
            <ReactQuill className='hover-box' value={editorValue} onChange={handleChange} placeholder={"Type something..."}
                modules={{
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ size: ['small', false, 'large', 'huge'] }],
                        [{ font: [] }],
                        [{ color: [] }, { background: [] }],
                        [{ script: 'sub' }, { script: 'super' }],
                        ['blockquote', 'code-block'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
                        ['link'],
                        ['clean'],
                    ],
                }}
            />
        </>
    );


}